import useAttribute from "@hooks/useAttribute"
import _ from "lodash"

export default function useAttributes(
    user: Model.Response<Admin.Resources.User>
): Admin.Models.User.Attrs {
    const name = useNameAttribute(user)

    return {
        name
    }
}

function useNameAttribute(user: Model.Response<Admin.Resources.User>) {
    return useAttribute(user.data, user => {
        return `${user.first_name} ${user.last_name}`
    }, "Loading...")
}